/**
 * Base URL for static uploads (no /api suffix).
 * Strips only a trailing /api path segment — safe when the host is api.example.com.
 */
export function getUploadBaseUrl(apiUrl = process.env.VUE_APP_API_URL) {
  if (!apiUrl) return '';
  return String(apiUrl).replace(/\/api\/?$/, '');
}

/**
 * Build a full URL for a file under /uploads/.
 * @param {string} relativePath e.g. "society/logos/foo.jpg", "visitors/pic.jpg", or "/uploads/chat/media/foo.jpg"
 */
export function resolveUploadUrl(relativePath, apiUrl) {
  if (!relativePath) return null;
  const raw = String(relativePath).trim();
  if (raw.startsWith('http://') || raw.startsWith('https://')) return raw;
  const base = getUploadBaseUrl(apiUrl);
  if (raw.startsWith('/')) {
    return `${base}${raw}`;
  }
  const path = raw.replace(/^\/?uploads\//, '');
  return `${base}/uploads/${path}`;
}
